module.exports = __webpack_public_path__ + "2703c956ecd73aac6c225ccb4e234df7.MP3";